var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlankVehicle = function SvgBlankVehicle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 95,
    viewBox: "0 0 141 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2294_25150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 142,
    height: 95
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.232422,
    y: 0.767578,
    width: 141,
    height: 94,
    rx: 4,
    fill: "#672B2B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2294_25150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.21191,
    y: -10.002,
    width: 144.917,
    height: 111.625,
    fill: "url(#pattern0_2294_25150)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 98,
    transform: "translate(-0.722168 0.267578)",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.969 40.3045L81.2431 37.2263C80.1483 35.2739 78.0844 34.0649 75.846 34.0649H64.8589C62.634 34.0649 60.5805 35.2594 59.4805 37.1933L57.6122 40.478L57.2897 39.9599L53.9765 39.96C53.0445 39.9601 52.289 40.7156 52.2891 41.6476C52.2891 42.5796 53.0446 43.3351 53.9766 43.335L55.4152 43.335L55.6804 43.7609C53.7876 44.281 52.3734 46.0144 52.3734 48.1016V61.808C52.3734 63.0507 53.3807 64.058 54.6234 64.058H57.9984C59.241 64.058 60.2484 63.0507 60.2484 61.808L60.2484 59.9809H80.3171V61.808C80.3171 63.0507 81.3245 64.058 82.5671 64.058H85.9421C87.1847 64.058 88.1921 63.0507 88.1921 61.808V54.3758L88.1921 54.3559V48.1449C88.1921 46.0763 86.8038 44.3575 84.9399 43.8196L84.8529 43.6644L85.058 43.335L86.4966 43.335C87.4286 43.3351 88.1841 42.5796 88.1841 41.6476C88.1842 40.7156 87.4287 39.9601 86.4967 39.96L83.1835 39.9599L82.969 40.3045ZM64.8589 37.4399C63.8476 37.4399 62.9141 37.9829 62.4142 38.8619L59.5955 43.8174L65.1348 44.2895C69.1468 44.6315 73.1813 44.6139 77.1901 44.2367L80.9403 43.8839C80.9482 43.8081 80.9613 43.7325 80.9797 43.6575L78.2992 38.8769C77.8016 37.9895 76.8635 37.4399 75.846 37.4399H64.8589ZM84.7933 47.9129L79.9059 49.4129C78.4922 49.8469 77.4153 50.9989 77.0777 52.4387C76.9114 53.1477 77.5068 53.8035 78.2285 53.7063L84.8171 52.8192V54.3559C84.8171 55.5986 83.8098 56.6059 82.5671 56.6059H57.9984C56.7557 56.6059 55.7484 55.5986 55.7484 54.3559V52.8192L62.3371 53.7063C63.0588 53.8035 63.6542 53.1477 63.4879 52.4387C63.1502 50.9989 62.0734 49.8469 60.6596 49.4129L55.7645 47.9105C55.861 47.3457 56.3773 46.9303 56.9689 46.9807L64.8481 47.6524C69.0607 48.0114 73.2969 47.9929 77.5062 47.5969L83.5868 47.0249C84.1675 46.9702 84.6787 47.3656 84.7933 47.9129Z",
    fill: "#5A5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2294_25150",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2294_25150",
    transform: "matrix(0.00332013 0 0 0.00431034 -0.00299975 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2294_25150",
    width: 303,
    height: 232,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS8AAADo"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlankVehicle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "blankVehicle.1ceb91a35db54dce194ee7730a07e754.svg";